// Generates a random UID
export function generateUID() {
    // Math.random should be unique because of its seeding algorithm. Convert it
    // to base 36 (numbers + letters), and grab the first 9 characters after the
    // decimal.
    return Math.random()
        .toString(36)
        .substr(2, 9);
}
// Takes Cookies (from react-cookie) as an arg. Checks for an existing UID, and
// either returns it or creates one & sets it in a cookie if it doesn't exist
export function setUID(cookies) {
    let uid = cookies.get('RWuid');
    if (!uid) {
        uid = generateUID();
        cookies.set('RWuid', uid);
    }
    return uid;
}
//# sourceMappingURL=uid.js.map